__turbopack_context__.v({
  "centered": "Container-module__CIWc4W__centered",
  "container": "Container-module__CIWc4W__container",
});
